import { z } from "zod";

export const ConfigSchema = z.object({
  analytics_configurable: z.boolean(),
  cloud_providers: z.array(
    z.enum(["aws", "azure", "gcp", "tencentcloud", "k8s"]),
  ),
  dev_flags: z.array(
    z
      .enum([
        "new-cost",
        "initiatives",
        "jun0",
        "admin-settings", // whether access model configuration is visible from Settings -> Access Model (TODO: FF name could be more specific)
        "ui-v2",
        "notification-rules",
        "operator-api",
        "anthropic-integration",
      ])
      .optional(),
  ),
  customer: z.string(),
  is_poc: z.boolean(),
  private_instance: z.boolean(),
  segment_write_key: z.string(),
  sentry_enabled: z.boolean(),
  limited_visibility: z.boolean(),
  system_dashboards: z.boolean().optional(),
  hidden_dashboard_keys: z.array(z.string()).optional(),
  /**
   * The platform API's own endpoints. `ws_uri` is the GraphQL subscriptions
   * service. Every platform publishes one; a platform older than the service
   * has none.
   *
   * Optional because the console deploys separately from the platform, so a
   * platform predating the service blocks serves neither this nor the rest of
   * them. The remaining blocks aren't declared here at all — the console still
   * reads those services from their own files.
   */
  api: z.object({ url: z.string(), ws_uri: z.string().optional() }).optional(),
});

export type AppConfig = z.infer<typeof ConfigSchema>;
